import { useExperimentBucket } from '@carvana/experiment';
import { useContext, useEffect, useState } from 'react';
import AnimateHeight from 'react-animate-height';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import type WithClassName from './WithClassName';

function BedLength({ className }: WithClassName) {
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const experimentBucket = useExperimentBucket('srch-set-reduction2');
  const [expand, setExpand] = useState(false);

  const show =
    (experimentBucket === 'control'
      ? appliedFilters.bodyStyles?.includes('Pickup') &&
        facetData?.truckBedLengths?.buckets &&
        facetData?.truckBedLengths?.buckets?.length > 0
      : facetData?.truckBedLengths?.buckets.some(
          bedLength => bedLength.count > 0
        )) || false;

  useEffect(() => {
    if (!show) setExpand(false);
  }, [show]);

  return (
    <AnimateHeight duration={500} height={show ? 'auto' : 0}>
      <FilterDrawer
        className={className}
        dataQa="facet-bed-length"
        facetContent={facetData?.truckBedLengths?.buckets}
        facetName="Bed Length"
        show={expand}
        onToggle={() => setExpand(v => !v)}
      >
        <CommonWrapper>
          {facetData?.truckBedLengths?.buckets?.map(
            ({ key, count, displayName }) => (
              <Checkbox
                facet="truckBedLengths"
                filter={key}
                id={`bed-length-${displayName}`}
                key={displayName}
                label={
                  <LabelWithCount count={count} displayName={displayName} />
                }
                checked={appliedFilters?.truckBedLengths?.some(
                  length => length === key
                )}
                onChange={() =>
                  updateListFilter({
                    filterKey: 'truckBedLengths',
                    value: key
                  })
                }
              />
            )
          )}
        </CommonWrapper>
      </FilterDrawer>
    </AnimateHeight>
  );
}

export default BedLength;
